<template>
  <div class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar v-if="style === 'vertical'" class="sidebar-container" />
    <!-- <Topbar v-else class="sidebar-container" /> -->
    <div :class="{ hasTagsView: needTagsView, horizontalContainer: style === 'horizontal' }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }" style="position: relative">
        <img src="@/assets/main_images/navbar/navbar_bg.png" alt="" class="navbar_bg">
        <navbar />
        <!-- <tags-view v-if="needTagsView" /> -->
      </div>
      <app-main />
      <!-- <right-panel>
                    <settings />
                  </right-panel> -->
    </div>
    <el-dialog v-dialogDrag :title="$t('close.title')" :show-close="false" :visible.sync="dialogVisible" width="850px"
      v-if="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
      <el-scrollbar style="height: 350px;">
        <div v-if="!nextShow" class="pre">
          <div class="user">{{ $t('ruleNotice.user') }}</div>
          <div class="content">{{ $t('ruleNotice.content') }}</div>
          <div class="signOffBox">
            <div class="signOff">{{ $t('ruleNotice.signOff') }}</div>
            <div class="data">{{ $t('ruleNotice.data') }}</div>
          </div>
        </div>
        <div v-if="nextShow" class="pre">
          <div class="title">{{ $t('ruleNotice.p1') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p2') }}</div>
          <div class="p1">{{ $t('ruleNotice.p3') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p4') }}</div>
          <div class="p1">{{ $t('ruleNotice.p5') }}</div>
          <div class="p1">{{ $t('ruleNotice.p6') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p7') }}</div>
          <div class="p1">{{ $t('ruleNotice.p8') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p9') }}</div>
          <div class="p1">{{ $t('ruleNotice.p10') }}</div>
          <div class="p1">{{ $t('ruleNotice.p11') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p12') }}</div>
          <div class="p1">{{ $t('ruleNotice.p13') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p14') }}</div>
          <div class="p1">{{ $t('ruleNotice.p15') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p16') }}</div>
          <div class="p1">{{ $t('ruleNotice.p17') }}</div>
          <div class="p1">{{ $t('ruleNotice.p18') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p19') }}</div>
          <div class="p1">{{ $t('ruleNotice.p20') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p21') }}</div>
          <div class="p1">{{ $t('ruleNotice.p22') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p23') }}</div>
          <div class="p1">{{ $t('ruleNotice.p24') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p25') }}</div>
          <div class="p1">{{ $t('ruleNotice.p26') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p27') }}</div>
          <div class="p1">{{ $t('ruleNotice.p28') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p29') }}</div>
          <div class="p1">{{ $t('ruleNotice.p30') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p31') }}</div>
          <div class="p1">{{ $t('ruleNotice.p32') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p33') }}</div>
          <div class="p1">{{ $t('ruleNotice.p34') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p35') }}</div>
          <div class="p1">{{ $t('ruleNotice.p36') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p37') }}</div>
          <div class="p1">{{ $t('ruleNotice.p38') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p39') }}</div>
          <div class="p1">{{ $t('ruleNotice.p40') }}</div>
          <div class="p1">{{ $t('ruleNotice.p41') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p42') }}</div>
          <div class="p1">{{ $t('ruleNotice.p43') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p44') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p45') }}</div>
          <div class="p1">{{ $t('ruleNotice.p46') }}</div>
          <div class="p1">{{ $t('ruleNotice.p47') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p48') }}</div>
          <div class="litte-title1">{{ $t('ruleNotice.p49') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p50') }}</div>
          <div class="p1">{{ $t('ruleNotice.p51') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p52') }}</div>
          <div class="p1">{{ $t('ruleNotice.p53') }}</div>
          <div class="p1">{{ $t('ruleNotice.p54') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p55') }}</div>
          <div class="p1">{{ $t('ruleNotice.p56') }}</div>
          <div class="litte-title">{{ $t('ruleNotice.p57') }}</div>
          <div class="p1">{{ $t('ruleNotice.p58') }}</div>
        </div>
      </el-scrollbar>
      <div style="text-align: right" v-if="!nextShow">
        <el-button style="margin-top:10px;" type="primary" size="small" @click="acept">{{ $t('close.determine') }}
          <!--查找--></el-button>
      </div>
      <div v-else style="display: flex;justify-content: space-between;">
        <el-checkbox style="margin-top: 10px;" v-model="nextShowCheck">{{ $t('close.nextDisplay') }}</el-checkbox>
        <el-button style="margin-top: 10px;" type="primary" size="small" key="oldBtn" disabled v-if="num > 0">{{
          $t('close.agree') + '(' + num + ')' }} <!--查找--></el-button>
        <el-button style="margin-top: 10px;" type="primary" size="small" @click="agree" key="newBtn" v-else>{{
          $t('close.agree') }} <!--查找--></el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag :title="formatterAnnouncementTypes(announcement.announcementType)"
      :visible.sync="dialogVisible1" width="850px" v-if="dialogVisible1" :append-to-body="true"
      :close-on-click-modal="false">
      <el-scrollbar style="min-height: 350px;" v-if="!noUpdataAnnouncement">
        <h2 class="announcement_title">{{ ifZh ? announcement.titleCn : announcement.titleEn }}</h2>
        <div class="line"></div>
        <Editor v-if="ifZh" v-model="announcement.contentCn" :readOnly="true" element-loading-text="图片较大，压缩中，请稍后..."
          :defaultConfig="editorConfig" :style="{ 'min-height': '300px', overflowY: 'hidden' }" />
        <Editor v-else v-model="announcement.contentEn" :readOnly="true" element-loading-text="图片较大，压缩中，请稍后..."
          :defaultConfig="editorConfig" :style="{ 'min-height': '300px', overflowY: 'hidden' }" />
      </el-scrollbar>
      <template v-else>
        <NoticeZh v-if="ifZh" />
        <NoticeCn v-else />
      </template>
      <div style="display: flex;justify-content: space-between">
        <el-checkbox v-model="nextShowCheck">{{ $t('close.nextDisplay') }}</el-checkbox>
        <el-button type="primary" size="small" @click="agree1" key="newBtn">{{
          $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import RightPanel from '@/components/RightPanel'
import {
  AppMain,
  Navbar,
  Settings,
  Sidebar,
  Topbar,
  TagsView,
} from "./components";
import { getNewAnnouncement } from '@/api/platformAdmin/annAdmin'
import { getDicTypeList } from "@/api/platformAdmin/digitalDitionary";
import moment from "moment";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import { updateNextShow } from '@/api/user'
import { getIe8n } from "@/utils/auth";
import NoticeZh from '@/layout/components/notice/noticeZh.vue'
import NoticeCn from '@/layout/components/notice/noticeCn.vue'
import { Editor } from "@wangeditor/editor-for-vue";
export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    // RightPanel,
    Settings,
    Sidebar,
    Topbar,
    TagsView,
    NoticeZh,
    NoticeCn,
    Editor
  },
  mixins: [ResizeMixin],
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      textContent: '',
      nextShow: false,
      nextShowCheck: false,
      num: 10,
      ifZh: true,
      toolbarConfig: {
        excludeKeys: [
          'group-video', // 隐藏视频相关按钮,
          'fullScreen' // 关键：排除全屏功能
        ],
      },
      announcement: {},
      noUpdataAnnouncement: false,
      enterpriseTypeList: [],
      editorConfig: {
        placeholder: "请输入内容...",
        readOnly: false,
        MENU_CONF: {
          uploadImage: {
            customUpload: this.customUploadImage, // 自定义图片上传逻辑
          },
        },
      },
    }
  },
  created() {
    this.ifZh = getIe8n() === "zh";
  },
  mounted() {
    if (this.$store.state.user.nextShow === 0) {
      this.dialogVisible = true;
    } else if (this.$store.state.user.nextShow === 2) {
      this.initAnnouncement();
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      style: (state) => state.settings.style,
      // showSettings: state => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    async initAnnouncement() {
      this.getEnterpriseTypeList();
      let res = await getNewAnnouncement(['获取最新公告']);
      this.announcement = res.data
      if (this.announcement) {
        let expiryTime = this.announcement.expiryTime;
        let userId = this.$store.state.user.usid;
        if (moment().isBefore(expiryTime) || expiryTime == null) {
          this.nextShowCheck = false;
          this.dialogVisible1 = true;
          if (this.$store.state.user.nextShow !== 2) {
            updateNextShow(userId, 2, [''], false).then(res => {
              this.$store.commit('user/SET_NEXTSHOW', 2)
            })
          }
        } else {
          updateNextShow(userId, 1, ['']).then(res => {
            this.$store.commit('user/SET_NEXTSHOW', 1)
          })
        }
      } else {  //兼容没发布新公告之前功能
        this.noUpdataAnnouncement = true;
      }
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    formatterAnnouncementTypes(announcementType) {
      let obj = this.enterpriseTypeList.find(item => item.dicTypeCode === announcementType);
      if (!this.noUpdataAnnouncement) {
        if (this.ifZh) {
          return obj?.dicTypeName || announcementType
        } else {
          return obj?.extInfo || announcementType
        }
      } else {
        return this.$t('close.title1');
      }

    },
    getEnterpriseTypeList() {
      getDicTypeList({ dicCode: 'announcement_management' }, ['数字字典查询', "announcement_management"]).then(res => {
        this.enterpriseTypeList = res.data
      })
    },
    getNewAnnouncement() {
      return getNewAnnouncement(['获取最新公告'])
    },
    acept() {
      this.nextShow = true;
      const txt = this.ifZh ? '/file/zh-cn.txt' : '/file/en.txt'
      fetch(txt)
        .then(response => response.text())
        .then(data => {
          this.textContent = data;
          this.updateTime();
        })
        .catch(error => {
          console.error('Error fetching TXT file:', error);
        });
    },
    updateTime() {
      if (this.num > 0) {
        this.num--;
        setTimeout(this.updateTime, 1000);
      }
    },
    agree() {
      let userId = this.$store.state.user.usid;
      let nextShow = this.nextShowCheck ? 1 : 0;
      updateNextShow(userId, nextShow, ['']).then(res => {
        this.dialogVisible = false;
        this.$store.commit('user/SET_NEXTSHOW', nextShow);
        this.initAnnouncement();
      })
    },
    agree1() {
      let userId = this.$store.state.user.usid;
      let nextShow = this.nextShowCheck ? 1 : 2;
      if (this.nextShowCheck) {
        updateNextShow(userId, nextShow, ['']).then(res => {
          this.dialogVisible1 = false;
          this.$store.commit('user/SET_NEXTSHOW', nextShow)
        })
      } else {
        this.dialogVisible1 = false;
        this.$store.commit('user/SET_NEXTSHOW', 1)
      }

    }
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 64px);
}

.mobile .fixed-header {
  width: 100%;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.pre {
  .content {
    text-indent: 2em;
  }

  .signOffBox {
    position: absolute;
    bottom: 60px;
    right: 20px;
  }

  .title {
    font-size: 20px;
    margin: 10px 0px 20px 0px;
  }

  .p1 {
    text-indent: 2em;
  }

  .litte-title {
    margin: 10px 0px;
  }

  .litte-title1 {
    margin: 10px 0px;
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #ccced6;
}

.announcement_title {
  font-size: 24px;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 10px;
}
</style>
